<template>
  <div class="nav-header">
    <div class="nav-container">
      <div class="nav-left">
        <div class="nav-menu">
          <div 
            v-for="(item, index) in menuItems" 
            :key="index"
            class="menu-item"
            :class="{ active: currentPath === item.path }"
            @click="handleNavClick(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabHeader',
  
  data() {
    return {
      currentPath: '/discover',
      menuItems: [
        { name: '作品', path: '/home/creation/explore' },
        { name: '圈子', path: '/home/community/circleList' },
      ]
    }
  },
  
  created() {
    this.currentPath = this.$route.path
  },
  
  methods: {
    handleNavClick(item) {
      if (this.currentPath !== item.path) {
        this.currentPath = item.path
        this.$router.push(item.path)
      }
    },
    
    handlePublish() {
      this.$router.push('/orderQuery')
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-header {
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 60px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
  margin: 0 auto;
  .nav-container {
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .nav-left {
      display: flex;
      align-items: center;
      gap: 40px;
      
      .logo {
        height: 32px;
        width: auto;
        cursor: pointer;
      }
      
      .nav-menu {
        display: flex;
        gap: 24px;
        
        .menu-item {
          font-size: 15px;
          color: #666;
          cursor: pointer;
          padding: 6px 2px;
          position: relative;
          
          &:hover {
            color: #ff6b00;
          }
          
          &.active {
            color: #ff6b00;
            font-weight: 500;
            
            &:after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 2px;
              background: #ff6b00;
              border-radius: 1px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .nav-header {
    .nav-container {
      padding: 0 12px;
      
      .nav-left {
        gap: 20px;
        
        .nav-menu {
          gap: 16px;
          
          .menu-item {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style> 